// AppDownload.jsx
import React from "react";
import appImage from "../assets/images/appBanner.png";
import androidBCode from "../assets/images/android.png";
import iosBCode from "../assets/images/ios.png";
import iosBlack from "../assets/images/iosBlack.png";
import playBlack from "../assets/images/playBlack.png";
import { Container, Row, Col } from "react-bootstrap";
import { FaCheckCircle, FaMobileAlt } from "react-icons/fa";

export default function AppDownload() {
  return (
    <div
      id="download-app"
      style={{
        background: "#f8fafd",
        padding: "70px 0",
        borderTop: "1px solid #e5ebf8",
      }}
    >
      <Container>
        <Row className="align-items-center g-4 g-lg-5">
          {/* Left Column: Phone Mockup Image */}
          <Col lg={6} className="text-center d-flex align-items-center justify-content-center">
            <div style={{ position: "relative", width: "100%", maxWidth: "540px" }}>
              <div
                style={{
                  position: "absolute",
                  inset: "5%",
                  background:
                    "radial-gradient(circle, rgba(40, 6, 249, 0.18) 0%, transparent 70%)",
                  filter: "blur(30px)",
                  zIndex: 0,
                  pointerEvents: "none",
                }}
              />
              <img
                src={appImage}
                alt="BeyondLottery Mobile App"
                className="img-fluid"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  position: "relative",
                  zIndex: 1,
                  filter: "drop-shadow(0 15px 30px rgba(12, 21, 56, 0.12))",
                }}
              />
            </div>
          </Col>

          {/* Right Column: Title, Subtitle, Highlights, and QR Download Cards */}
          <Col lg={6} className="text-center text-lg-start d-flex flex-column justify-content-center">
            <div style={{ maxWidth: "520px", margin: "0 auto" }}>
              <span
                style={{
                  display: "inline-block",
                  background: "rgba(40, 6, 249, 0.08)",
                  color: "#2806f9",
                  fontSize: "12px",
                  fontWeight: 700,
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  padding: "5px 14px",
                  borderRadius: "20px",
                  marginBottom: "12px",
                  border: "1px solid rgba(40, 6, 249, 0.18)",
                }}
              >
                <FaMobileAlt style={{ marginRight: "6px" }} /> Mobile Management
              </span>

              <h2
                style={{
                  fontSize: "32px",
                  fontWeight: 800,
                  color: "#0c1538",
                  lineHeight: 1.25,
                  marginBottom: "12px",
                  letterSpacing: "-0.5px",
                }}
              >
                Download Our <span style={{ color: "#2806f9" }}>BeyondLottery</span> App
              </h2>

              <p
                style={{
                  fontSize: "14.5px",
                  color: "#586380",
                  lineHeight: 1.55,
                  marginBottom: "20px",
                }}
              >
                Scan the QR code or click the download buttons below to install and manage your lottery screens from any smartphone.
              </p>

              {/* Inline Feature Tags */}
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  marginBottom: "24px",
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    background: "#ffffff",
                    border: "1px solid #e2e8f5",
                    padding: "6px 12px",
                    borderRadius: "16px",
                    fontSize: "12.5px",
                    fontWeight: 600,
                    color: "#0c1538",
                    boxShadow: "0 2px 6px rgba(12, 21, 56, 0.03)",
                  }}
                >
                  <FaCheckCircle style={{ color: "#2806f9", fontSize: "11px" }} /> Live Updates
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    background: "#ffffff",
                    border: "1px solid #e2e8f5",
                    padding: "6px 12px",
                    borderRadius: "16px",
                    fontSize: "12.5px",
                    fontWeight: 600,
                    color: "#0c1538",
                    boxShadow: "0 2px 6px rgba(12, 21, 56, 0.03)",
                  }}
                >
                  <FaCheckCircle style={{ color: "#2806f9", fontSize: "11px" }} /> Barcode Scanning
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    background: "#ffffff",
                    border: "1px solid #e2e8f5",
                    padding: "6px 12px",
                    borderRadius: "16px",
                    fontSize: "12.5px",
                    fontWeight: 600,
                    color: "#0c1538",
                    boxShadow: "0 2px 6px rgba(12, 21, 56, 0.03)",
                  }}
                >
                  <FaCheckCircle style={{ color: "#2806f9", fontSize: "11px" }} /> Multi-Store
                </span>
              </div>

              {/* QR Code Download Cards - Centered with clean generous gap */}
              <div
                style={{
                  display: "flex",
                  gap: "24px",
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                  width: "100%",
                }}
              >
                {/* iOS Card */}
                <div
                  style={{
                    background: "#ffffff",
                    padding: "16px 18px",
                    borderRadius: "16px",
                    border: "1.5px solid #e2e8f5",
                    boxShadow: "0 6px 20px rgba(12, 21, 56, 0.06)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "155px",
                    transition: "all 0.25s ease",
                  }}
                >
                  <img
                    src={iosBCode}
                    alt="iOS QR Code"
                    style={{
                      width: "105px",
                      height: "105px",
                      marginBottom: "12px",
                      objectFit: "contain",
                    }}
                  />
                  <a
                    href="https://apps.apple.com/us/app/beyond-lotto/id6476814704"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", display: "block", width: "100%" }}
                  >
                    <img
                      src={iosBlack}
                      alt="Download on App Store"
                      style={{ height: "36px", width: "100%", objectFit: "contain" }}
                    />
                  </a>
                </div>

                {/* Android Card */}
                <div
                  style={{
                    background: "#ffffff",
                    padding: "16px 18px",
                    borderRadius: "16px",
                    border: "1.5px solid #e2e8f5",
                    boxShadow: "0 6px 20px rgba(12, 21, 56, 0.06)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "155px",
                    transition: "all 0.25s ease",
                  }}
                >
                  <img
                    src={androidBCode}
                    alt="Android QR Code"
                    style={{
                      width: "105px",
                      height: "105px",
                      marginBottom: "12px",
                      objectFit: "contain",
                    }}
                  />
                  <a
                    href="https://play.google.com/store/apps/details?id=com.dueta.inventorycontrol"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", display: "block", width: "100%" }}
                  >
                    <img
                      src={playBlack}
                      alt="Get it on Google Play"
                      style={{ height: "36px", width: "100%", objectFit: "contain" }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
